function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFeedback = function SvgFeedback(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Leave Feedback",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3146"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 605",
    d: "M239.19 265.781h10.268a.932.932 0 0 1 .931.93v4.906a.932.932 0 0 1-.931.931h-7.777l-2.156 2.281a.224.224 0 0 1-.385-.189l.328-2.092h-.277a.932.932 0 0 1-.93-.931v-4.906a.932.932 0 0 1 .93-.93z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-238.26 -261.408)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 606",
    d: "M242.131 265.443v-1.1a.932.932 0 0 1 .931-.931h10.268a.932.932 0 0 1 .93.931v4.9a.932.932 0 0 1-.93.931h-.277l.328 2.092a.224.224 0 0 1-.385.189l-2.156-2.281h-.112v-3.464a1.27 1.27 0 0 0-1.269-1.268z",
    style: {
      fill: "#838383"
    },
    transform: "translate(-238.26 -261.408)"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2179",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feedback.f748cd69.svg";
export { ForwardRef as ReactComponent };